import React, { useState } from "react";
import { IconButton, Popover, ListItem, ListItemText, List, Menu } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import useStyles from "./style";

const MessageActions = ({
  className,
  handleForwardMessages,
  handleMessageInfo,
  showMessageInfo,
  isMessageStarred,
  handleStarMessage,
  copyTextToClipboard,
  from,
  hideShadow,
}) => {
  const {
    userInfo: { _id },
  } = useSelector((state) => state.user);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const popoverId = open ? "simple-popover" : undefined;
  const { t } = useTranslation();
  const classes = useStyles();

  const handleForwardMessage = () => {
    setAnchorEl(null);
    handleForwardMessages();
  };

  return (
    <>
      <IconButton
        onClick={(event) => setAnchorEl(event.currentTarget)}
        aria-label="setting"
        disableFocusRipple={true}
        disableRipple={true}
        className={className}
        style={{
          position: "absolute",
          top: "0px",
          right: "0px",
          backgroundColor: hideShadow
            ? "transparent"
            : from === _id
              ? "#34c759"
              : "rgb(239 239 244)",
          boxShadow: hideShadow
            ? "none"
            : `-1px 1px 5px 5px ${from === _id ? "#34c759" : "rgb(239 239 244)"}`,
          MozBoxShadow: hideShadow
            ? "none"
            : `-1px 1px 5px 5px ${from === _id ? "#34c759" : "rgb(239 239 244)"}`,
          WebkitBoxShadow: hideShadow
            ? "none"
            : `-1px 1px 5px 5px ${from === _id ? "#34c759" : "rgb(239 239 244)"}`,
        }}
        size="large"
      >
        <ExpandMore
          style={{ color: "gray", padding: 0, margin: 0, width: "20px", height: "20px" }}
        />
      </IconButton>
      <Menu
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        id={popoverId}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <List component="nav" aria-label="main mailbox folders" className={classes.List}>
          {showMessageInfo && (
            <>
              <ListItem
                className={classes.listItem}
                onClick={() => {
                  setAnchorEl(null);
                  handleMessageInfo();
                }}
              >
                <ListItemText className={classes.linkText} primary={t("Message Info")} />
              </ListItem>
              <hr
                style={{
                  border: "1px solid #F2F2F2",
                  width: "86%",
                  textAlign: "center",
                }}
              />
            </>
          )}

          <>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => {
                setAnchorEl(null);
                handleStarMessage();
              }}
            >
              <ListItemText
                className={classes.linkText}
                primary={isMessageStarred ? t("UnStar message") : t("Star message")}
              />
            </ListItem>
            <hr
              style={{
                border: "1px solid #F2F2F2",
                width: "86%",
                textAlign: "center",
              }}
            />
          </>
          <>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => {
                setAnchorEl(null);
                copyTextToClipboard();
              }}
            >
              <ListItemText className={classes.linkText} primary={t("Copy message")} />
            </ListItem>
            {/* <hr
              style={{
                border: "1px solid #F2F2F2",
                width: "86%",
                textAlign: "center",
              }}
            /> */}
          </>
          {/* <>
          <ListItem className={classes.listItem} button onClick={handleForwardMessage}>
            <ListItemText className={classes.linkText} primary={t("Forward message")} />
          </ListItem>
          <hr
            style={{
              border: "1px solid #F2F2F2",
              width: "86%",
              textAlign: "center",
            }}
          />
        </> */}
        </List>
      </Menu>
    </>
  );
};

export default MessageActions;
